
import { Profile } from '@/types/profile';

export const hasBasicInfo = (profile: Profile): boolean => {
  return !!(profile.bio || profile.occupation || profile.education || profile.relationship_type);
};

export const hasAppearanceInfo = (profile: Profile): boolean => {
  return !!(profile.height || profile.body_type || profile.hair_color || profile.eye_color);
};

export const hasLifestyleInfo = (profile: Profile): boolean => {
  return !!(profile.smoker || profile.drinker || profile.piercings || profile.tattoos);
};

export const hasRelationshipInfo = (profile: Profile): boolean => {
  return !!(profile.travel_availability || profile.marital_status || profile.relationship_type || profile.sigilo_presenca);
};
